import { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const ReferralsContext = createContext();

export const useReferrals = () => {
    const context = useContext(ReferralsContext);
    if (!context) {
        throw new Error('useReferrals must be used within a ReferralsProvider');
    }
    return context;
};

export const ReferralsProvider = ({ children }) => {
    const [pendingCount, setPendingCount] = useState(0);
    const { user } = useAuth();

    const fetchPendingCount = async () => {
        try {
            const referralsRes = await fetch("https://us-central1-workexpress-1ffff.cloudfunctions.net/app/referrals");
            if (!referralsRes.ok) return;

            const referralsData = await referralsRes.json();
            const referralsArray = Array.isArray(referralsData) ? referralsData : [referralsData];
            
            const pendingCount = referralsArray.filter(r => 
                !r.status || r.status.toLowerCase() === 'pending'
            ).length;
            setPendingCount(pendingCount);
        } catch (error) {
            console.error('Error fetching referrals count:', error);
        }
    };

    useEffect(() => {
        if (user) {
            // Fetch immediately on login
            fetchPendingCount();
            
            // Set up periodic refresh every 10 seconds
            const intervalId = setInterval(fetchPendingCount, 10000);
            return () => clearInterval(intervalId);
        } else {
            // Reset count when user logs out
            setPendingCount(0);
        }
    }, [user]);

    return (
        <ReferralsContext.Provider value={{ pendingCount, setPendingCount }}>
            {children}
        </ReferralsContext.Provider>
    );
};

